import loadable from '@loadable/component'

export const ProspectSiteHeader = loadable(() => import('./ProspectSiteHeader'))
export const SiteHeader = loadable(() => import('./SiteHeader'))
export { TOP_ANCHOR_ID } from './SiteHeader'
export type {
  LinkButtonProps,
  MarketoButtonProps,
  ProspectSiteHeaderProps
} from './ProspectSiteHeader'
export type { SiteHeaderProps } from './SiteHeader'
